import type { ValueSignature } from "@skilitics/nautilus-core-designer-data";

import type { ValueSubtypeDefinition } from "../valueSubtypeDefinition.ts";
import { coreValueSubtypeDefinitions } from "./coreValueSubtypeDefinitions.ts";
import { resolveValueSubtypeDefinition } from "./resolveValueSubtypeDefinition.ts";

/**
 * The definition governing a comparison over a value of `signature`. Total, as
 * `getManifest` is: there is always a definition, because the base one for the
 * signature's type stands behind every subtype.
 *
 * A designer app carries one of these, built from the definitions its packages
 * contribute, so a generic consumer edits an expression over a subtype it cannot
 * name without ever being handed a list to search.
 */
export type GetValueSubtypeDefinition = (signature: ValueSignature) => ValueSubtypeDefinition;

/**
 * The resolver over a fixed set of contributed definitions — the app builds one
 * at startup. Core's own definitions come first, so an app contributes only what
 * its packages declare and cannot leave a core subtype unresolved.
 */
export const getValueSubtypeDefinitionCreate =
  (contributed: readonly ValueSubtypeDefinition[]): GetValueSubtypeDefinition =>
  (signature) =>
    resolveValueSubtypeDefinition(signature, [...coreValueSubtypeDefinitions, ...contributed]);
